module.exports = __webpack_public_path__ + "media/images/front/icon_dba-fcc8e780193033aaf80fbfac66a03427.png";